const meta = {
  actions: 'Actions',
  alerts: 'Alerts',
  searches: 'Scheduled searches',
};

export default meta;
